import * as React from "react";
import { MediaLinesModel } from "../../model/autogen/MediaLinesModel";
import { PeopleItemRoute } from "../../route-paths";
import { Link } from "react-router-dom";
import { DocumentItem } from "../../model/autogen/DocumentItem";
import { RenderDocumentItemDisplay } from "./common";
import { downloadLinkResolver } from "pages/brief-item-page";
import { FileAttachmentList } from "components/file-attachment-list";

export function renderMediaLineContents(sortedItems: DocumentItem[], item: MediaLinesModel) {
    return <div>
        {item.spokesperson && <article>
            <h3>Spokesperson</h3>
            <p><Link to={PeopleItemRoute()(item.spokesperson.id)}>{item.spokesperson.name}</Link></p>
        </article>}
        {sortedItems.map((si) => RenderDocumentItemDisplay(si))}
        {item.files && <article>
            <h3>Attachments</h3>
            <FileAttachmentList files={item.files} downloadLinkResolver={downloadLinkResolver} editing={false} />
        </article>}
    </div>
}


// WEBPACK FOOTER //
// ./src/components/display/media-line-display.tsx